import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sym from '../components/Sym';

/**
 * Banda CTA azul reutilizable (cierre de Características / Seguridad / Precios).
 * Copy variable por página; el botón siempre lleva a registro.
 */
const CTABand2 = ({ title, subtitle, cta = 'Comienza tu prueba de 15 días', to = '/register' }) => {
  const navigate = useNavigate();
  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: '0 clamp(20px,5vw,40px) clamp(56px,8vw,104px)' }}>
      <div style={{ position: 'relative', overflow: 'clip', background: 'linear-gradient(120deg,#2F6BFF,#132C74)', borderRadius: 30, padding: 'clamp(36px,5vw,64px)', textAlign: 'center' }}>
        <div style={{ position: 'absolute', top: -80, right: -40, width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle,rgba(159,190,255,.45),transparent 62%)', filter: 'blur(8px)' }} />
        <h2 style={{ position: 'relative', font: "600 clamp(1.9rem,4.5vw,3rem)/1.05 'Source Serif 4'", color: '#fff', margin: '0 auto', maxWidth: 620, textWrap: 'balance' }}>{title}</h2>
        {subtitle && (
          <p style={{ position: 'relative', font: "400 1.12rem/1.55 'Hanken Grotesk'", color: '#D5DEFA', margin: '16px auto 30px', maxWidth: 500 }}>{subtitle}</p>
        )}
        <a
          onClick={() => navigate(to)}
          style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 9, background: '#fff', color: '#14213D', font: "700 1.06rem 'IBM Plex Mono'", padding: '16px 28px', borderRadius: 13, cursor: 'pointer', boxShadow: '0 16px 34px -12px rgba(0,0,0,.5)', transition: 'transform .18s' }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
        >
          {cta}<Sym name="arrow_forward" size={20} />
        </a>
      </div>
    </section>
  );
};

export default CTABand2;
